import appleLogo from "../../../static/logos/apple-logo--black.svg"
import googleLogo from "../../../static/logos/google-g-logo.svg"
import { AuthProviders } from "../hooks/support"

type SocialAuthProps = {
  authProviders?: AuthProviders
  mode: "signIn" | "signUp"
}

export const SocialAuth = function SocialAuth({ authProviders, mode }: SocialAuthProps) {
  const appleProvider = authProviders?.apple
  const googleProvider = authProviders?.google
  const appleEnabled = Boolean(appleProvider?.enabled)
  const googleEnabled = Boolean(googleProvider?.enabled)
  const hasSocialAuth = appleEnabled || googleEnabled

  if (!hasSocialAuth) return null

  const action = mode === "signIn" ? "Sign In" : "Sign Up"

  return (
    <>
      {appleEnabled && (
        <>
          <button
            id="custom-apple-signin"
            type="button"
            className="apple-sign-up__large--white"
            data-client-id={appleProvider?.client_id || ""}
            data-redirect-uri={appleProvider?.redirect_uri || ""}
            data-state={appleProvider?.state || ""}
            data-nonce={appleProvider?.nonce || ""}
            style={{ marginBottom: 16 }}
          >
            <img src={appleLogo} alt="Apple" className="apple-sign-up__large--white__logo" />
            {action} with Apple
          </button>
          <div
            id="appleid-signin"
            style={{ display: "none" }}
            data-color="black"
            data-border="true"
            data-border-radius="4"
            data-type="sign in"
          />
        </>
      )}
      {googleEnabled && (
        <>
          <button
            id="custom-google-signin"
            type="button"
            className="google-sign-in__large--white"
            data-client-id={googleProvider?.client_id || ""}
            data-nonce={googleProvider?.nonce || ""}
            tabIndex={0}
            style={{ marginBottom: 16 }}
          >
            <img src={googleLogo} alt="Google" className="google-sign-in__large--white__logo" />
            {action} with Google
          </button>
          <div id="googleid-signin" style={{ display: "none" }} />
        </>
      )}
    </>
  )
}
